<template>
    <div class="panel__container">
        <header class="panel__header">
            <h2 class="panel__title">General</h2>
        </header>
        <form @submit.prevent="save()" class="form">
            <div class="form__group" :class="{ 'form__group--error' : form.errors.has('name')}">
                <label for="name" class="form__label">Name</label>
                <input v-model="form.name" id="name" name="name" class="lc-name form__input" autofocus autocomplete="off">
                <p v-if="form.errors.has('name')" class="form__help form__help--error">{{ form.errors.get('name') }}</p>
            </div>
            <div class="form__group">
                <button type="submit" class="lc-submit button button--primary button--small" :disabled="form.busy">Save</button>
            </div>
        </form>
    </div>
</template>

<script>
/* global EventBus */
import Form from './../../../helpers/Form'
import { mapState } from 'vuex'

export default {
    data () {
        return {
            form: new Form({
                name: ''
            })
        }
    },

    created () {
        this.form.name = this.channel.name
    },

    methods: {
        save () {
            this.$store.dispatch('channel/updateChannel', this.form).then(() => {
                window.history.replaceState({}, this.channel.name, this.channel.settings_url)
                EventBus.$emit('newSnackbar', `General settings saved`)
            })
        }
    },

    computed: {
        ...mapState('users', {
            currentUser: 'current'
        }),

        ...mapState('channel', ['channel'])
    }
}
</script>
